import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@/scss/vuetify/overrides.scss'

const colors = {
    primary: '#1e88e5',
    info: '#1e88e5',
    success: '#21c1d6',
    accent: '#fc4b6c',
    default: '#563dea',
    spreadsheet: '#4f9d49'
}

switch (process.env.VUE_APP_INSTANCE) {
    case "hdh":
        colors.avgidea = '#ffffff'
        break
    case "d-ocean":
        colors.avgidea = '#1E90FF'
        break
    default:
        colors.avgidea = '#e89a37'
}

export default createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: { colors: { ...colors } },
            dark: { dark: true, colors: { ...colors } },
        },
    },
})
